import { j as t } from "../../../jsx-runtime-B6kdoens.js";
import { useTransitionStatus as T, useMergeRefs as C, FloatingPortal as b, FloatingArrow as v } from "@floating-ui/react";
import { c as r } from "../../../index-CROKJrb5.js";
import { a as w } from "../../../TooltipContext-BDAX-u97.js";
import { c as j, f as F } from "../../../create-component-CBAeEoQ6.js";
const R = r({
  base: "cur-p-2 cur-flex cur-gap-2 cur-text-meta cur-rounded cur-drop-shadow-[0_-4px_12px_rgba(116, 116, 116, 0.4)]",
  variants: {
    tooltipType: {
      default: "cur-bg-[#897aff]",
      highlight: "cur-bg-surface-highlight"
    }
  }
}), A = r({
  variants: {
    tooltipType: {
      default: "cur-fill-[#897aff]",
      highlight: "cur-fill-surface-highlight"
    }
  }
}), S = j(
  "Tooltip",
  F(
    ({ as: i, children: a, className: l, ...o }, n) => {
      const c = i || "div", {
        refs: p,
        tooltipType: e,
        strategy: f,
        x: u,
        y: g,
        styles: h,
        getFloatingProps: m,
        arrowRef: d,
        context: s
      } = w(), { status: x } = T(s), y = C([p.setFloating, n]);
      return /* @__PURE__ */ t.jsx(b, { children: /* @__PURE__ */ t.jsxs(
        c,
        {
          className: R({ tooltipType: e, className: l }),
          ref: y,
          style: {
            position: f,
            top: g ?? 0,
            left: u ?? 0,
            visibility: x === "unmounted" ? "hidden" : "visible",
            ...o.style,
            ...h
            // transition styles
          },
          ...m(o),
          children: [
            a,
            /* @__PURE__ */ t.jsx(
              v,
              {
                className: A({ tooltipType: e }),
                ref: d,
                context: s,
                height: 4,
                width: 8
              }
            )
          ]
        }
      ) });
    }
  )
);
export {
  S as TooltipContent
};
//# sourceMappingURL=index.js.map
